export default __webpack_public_path__ + "img/clock-time-eight.4e9bb1f4.svg";